import React, { useState, useContext } from "react";
import {
  AppBarSt,
  DrawerHeaderSt,
  DrawerSt,
} from "../components/SideDrawerStyles";
import { useParams } from "react-router-dom";
import { Link, NavLink } from "react-router-dom";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Badge from "@mui/material/Badge";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import MailIcon from "@mui/icons-material/Mail";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import TocIcon from "@mui/icons-material/Toc";
import PollIcon from "@mui/icons-material/Poll";
import LowPriorityIcon from "@mui/icons-material/LowPriority";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import RepeatIcon from "@mui/icons-material/Repeat";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import { AuthContext } from "../../context/AuthContext";
import { useDispatch } from "react-redux";

const DrawerHeader = DrawerHeaderSt;
const AppBar = AppBarSt;
const Drawer = DrawerSt;

const Navbar = (props) => {
  const dispatch = useDispatch();
  const Auth = useContext(AuthContext);
  let prefix;
  if (Auth.type === "laboratory") {
    prefix = "لابراتوار";
  } else {
    if (Auth.type === "doctor") {
      prefix = "مطب";
    } else {
      prefix = "";
    }
  }

  const theme = useTheme();
  const [tab, setTab] = useState("");
  const [open, setOpen] = useState(false);
  const [bright, setBright] = useState(false);
  const brightHandler = () => {
    setBright(!bright);
    props.modeHandler(!props.mode);
  };
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };
  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };
  const mobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <Link
        to="/lab/defaults/userInfo"
        style={{ color: "inherit", textDecoration: "inherit" }}
      >
        <MenuItem onClick={handleMobileMenuClose}>
          <IconButton size="large" color="inherit">
            <AccountCircle />
          </IconButton>
          <p>کاربری</p>
        </MenuItem>
      </Link>
      <MenuItem onClick={brightHandler}>
        <IconButton size="large" color="inherit">
          {bright === true ? <Brightness7Icon /> : <Brightness4Icon />}
        </IconButton>
        <p>{bright === true ? "روشن" : "خاموش"}</p>
      </MenuItem>
      <MenuItem onClick={handleMobileMenuClose}>
        <IconButton size="large" color="inherit">
          <PowerSettingsNewIcon />
        </IconButton>
        <p>خروج</p>
      </MenuItem>
    </Menu>
  );

  const name = Auth.name;
  const url = "http://localhost:3000";
  return (
    <Box sx={{ flexGrow: 1 }}>
      <CssBaseline />

      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            {`${prefix} ${Auth.name}`}
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: "none", sm: "flex", md: "flex" } }}>
            <Link
              to="/lab/defaults/userInfo"
              style={{ color: "inherit", textDecoration: "inherit" }}
            >
              <IconButton
                size="large"
                edge="end"
                color="inherit"
                to="/lab/defaults/userInfo"
                sx={{ mr: 1 }}
              >
                <AccountCircle />
              </IconButton>
            </Link>
            <IconButton
              size="large"
              edge="end"
              color="inherit"
              onClick={brightHandler}
              sx={{ mr: 1 }}
            >
              {bright === true ? <Brightness7Icon /> : <Brightness4Icon />}
            </IconButton>
            <Link
              to="/login"
              style={{ color: "inherit", textDecoration: "inherit" }}
            >
              <IconButton
                size="large"
                edge="end"
                color="inherit"
                sx={{ mr: 1 }}
                onClick={Auth.logout}
              >
                <PowerSettingsNewIcon />
              </IconButton>
            </Link>
          </Box>
          <Box
            sx={{
              display: { xs: "flex", md: "none", sm: "none" },
              mr: 2,
            }}
          >
            <IconButton
              size="large"
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreVertIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {mobileMenu}
      <Drawer variant="permanent" open={open} onClick={handleDrawerClose}>
        <DrawerHeader sx={{ display: "flex", justifyContent: "space-between" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Layer_1"
            data-name="Layer 1"
            viewBox="0 0 600.47 515"
            fill="#0ba39d"
            style={{ width: "20%", marginRight: "13px" }}
          >
            <path
              class="cls-1"
              d="m494.4,179.99l-21.35-27.96-21.87,27.96h14.57c0,91.14-74.15,165.29-165.29,165.29-45.91,0-90.13-19.33-121.33-53.04l-.07-.07c-6.83-7.19-24.33-28.96-23.33-43.22.96-13.71,6.46-18.57,21.04-18.57h24.51c13.43,0,19.66,15.35,27.63,38.76,7.23,21.23,14.7,43.18,34.98,43.18,18.55,0,21.01-20.79,22.98-37.5,2.49-21.06,4.91-29.86,13.51-29.86s10.72,8.69,12.91,29.47c.91,8.62,1.77,16.75,4.25,23.44,4.43,11.94,12.63,14.44,18.74,14.44,14.67,0,25.5-16.91,30.64-26.99,7.81-15.29,12.47-33.95,12.47-49.9,0-13.49-3.3-24.96-9.55-33.17-5.23-6.87-15.33-15.05-33.76-15.05h-87.96c-2.54-4.32-7.22-7.22-12.59-7.22-8.07,0-14.6,6.54-14.6,14.6s6.54,14.6,14.6,14.6c5.39,0,10.09-2.93,12.62-7.28h87.92c10.1,0,17.32,3.03,22.07,9.26,4.28,5.62,6.54,14.01,6.54,24.26,0,30.22-18.48,62.19-28.42,62.19-1.41,0-3.16,0-4.96-4.86-1.84-4.96-2.6-12.2-3.41-19.87-1.9-17.99-4.49-42.63-27.53-42.63s-25.97,24.76-28.1,42.84c-.9,7.62-1.75,14.81-3.61,19.73-1.82,4.8-3.52,4.8-4.77,4.8-9.08,0-14.24-13.15-21.07-33.22-7.77-22.84-16.58-48.73-41.55-48.73h-24.51c-22.19,0-34.21,10.85-35.7,32.25-1.62,23.15,24.17,51.04,27.31,54.34,33.97,36.68,82.11,57.72,132.08,57.72,99.25,0,179.99-80.74,179.99-179.99h13.95Z"
            />
            <path
              class="cls-1"
              d="m149.3,179.99h-14.19c0-91.14,74.15-165.29,165.29-165.29,43.4,0,84.4,16.69,115.51,47.06,24.61,23.46,31.47,51.56,26.96,62.83-1.4,3.5-3.6,5-7.36,5h-36.97c-6.42,0-11.33-10.56-16.52-21.73-7.54-16.23-16.93-36.43-38.66-36.43-11.43,0-21.76,5.28-30.06,9.51-4.98,2.54-10.12,5.17-12.9,5.17-3.18,0-9.8-3.11-15.65-5.85-8.83-4.14-18.83-8.83-27.92-8.83-13.44,0-36,6.55-36,50.44,0,16.94,4.63,29.98,13.77,38.76,8.39,8.06,20.13,12.14,34.89,12.14h82.98c2.54,4.32,7.22,7.23,12.59,7.23,8.07,0,14.6-6.54,14.6-14.6s-6.54-14.6-14.6-14.6c-5.39,0-10.09,2.93-12.62,7.28h-82.95c-22.86,0-33.97-11.84-33.97-36.2,0-35.73,16.03-35.73,21.3-35.73,5.81,0,14.24,3.95,21.67,7.44,7.94,3.72,15.44,7.24,21.89,7.24s12.76-3.29,19.58-6.77c7.26-3.71,15.49-7.91,23.38-7.91,11.49,0,17.49,11.06,25.33,27.92,6.91,14.86,14.05,30.23,29.85,30.23h36.97c9.73,0,17.39-5.19,21.01-14.24,3.86-9.65,2.99-22.96-2.45-37.48-5.54-14.79-15.49-29.51-27.96-41.39C392.31,18.18,347.66,0,300.4,0,201.15,0,120.41,80.74,120.41,179.99h-14.34l21.35,27.96,21.87-27.96Z"
            />
            <path
              class="cls-1"
              d="m63.02,460.1c-2.43-1.37-2.83-4.68-.67-6.43,6.12-4.94,9.18-11.61,9.18-20s-3.31-15.45-9.93-20.98c-6.62-5.53-14.96-8.29-25-8.29-11.37,0-20.31,3.42-26.82,10.25-6.51,6.83-9.77,16.1-9.77,27.81v72.54h14.74v-69.94c0-9.43,1.76-16.37,5.3-20.82,3.53-4.44,9-6.67,16.39-6.67,5.74,0,10.49,1.63,14.24,4.88,3.75,3.25,5.63,7.38,5.63,12.36,0,6.07-2.47,10.66-4.42,12.85-1.19,1.34-3.44,2.98-5.57,4.06-2.22,1.12-3.59,3.4-3.58,5.88v.13c0,3.2,2.27,5.91,5.43,6.69,2.52.62,4.86,1.77,7.27,4.2,4.04,4.07,6.5,7.83,6.5,14.98,0,12.58-7.95,17.91-23.84,17.91h-2.95v13.49h6.59c10.82,0,19.43-2.77,25.83-8.29,6.4-5.53,9.6-12.9,9.6-22.12,0-11.02-4.71-19.19-14.14-24.49Z"
            />
            <path
              class="cls-1"
              d="m147.4,442.42c-9.35-6.08-19.21-8.02-29.6-5.81-10.39,2.2-18.59,7.93-24.6,17.18-5.96,9.16-7.78,19-5.47,29.52,2.31,10.52,8,18.73,17.07,24.63,16.66,10.83,33.19,9.2,49.59-4.89l-6.22-8.26c-6.03,5.43-10.97,7.48-17.33,8.35-6.36.87-12.46-.59-18.29-4.38-6.2-4.03-10.02-9.8-11.45-17.32-1.43-7.51-.07-14.47,4.08-20.85,4.15-6.38,9.62-10.34,16.4-11.85,6.78-1.52,13.23-.29,19.33,3.68,6.29,4.09,9.81,9.41,10.56,15.96l-42.93.57v11.27s55.84-.11,55.84-.11c1.09-17.07-4.57-29.63-16.97-37.69Z"
            />
            <path
              class="cls-1"
              d="m213.91,438.18c-10.49,0-18.38,4.3-23.68,12.92v-46.69h-13.25v110.61h13.25v-37.75c0-8.06,1.82-14.4,5.46-19.04,3.64-4.64,8.55-6.95,14.74-6.95,12.14,0,18.21,7.67,18.21,23.02v40.73h13.25v-43.88c0-10.04-2.54-18.05-7.62-24.01-5.08-5.96-11.87-8.94-20.37-8.94Z"
            />
            <path
              class="cls-1"
              d="m264.15,404.4c-2.76,0-5.08.94-6.95,2.81-1.88,1.88-2.82,4.14-2.82,6.79s.94,5.08,2.82,6.95c1.88,1.88,4.19,2.82,6.95,2.82s4.91-.94,6.79-2.82c1.88-1.88,2.82-4.19,2.82-6.95s-.94-4.91-2.82-6.79c-1.88-1.88-4.14-2.81-6.79-2.81Z"
            />
            <rect
              class="cls-1"
              x="257.69"
              y="439.67"
              width="14.21"
              height="75.34"
            />
            <path
              class="cls-1"
              d="m392.72,500.82c-2.93-.77-5.14-2.11-7.57-4.27-2.43-2.16-4.14-4.9-5.13-8.22-.99-3.32-1.49-8.14-1.49-14.45v-69.76h-14.74v72.74c0,13.29,2.95,22.95,8.86,28.98,5.9,6.03,15.32,9.05,28.23,9.05h20.2v-13.66h-15.74c-5.52.01-9.69.38-12.61-.4Z"
            />
            <path
              class="cls-1"
              d="m470.26,437.89c-11.04,0-20.4,3.79-28.07,11.35-7.67,7.57-11.51,16.69-11.51,27.37s3.7,19.88,11.09,27.28c7.39,7.41,16.39,11.11,26.99,11.11,4.41,0,8.28-.6,11.59-1.8,3.31-1.2,6.73-3.27,10.27-6.21v-13.89c-6.85,5.99-13.58,8.99-20.2,8.99-7.4,0-13.58-2.45-18.55-7.35-4.97-4.9-7.45-10.95-7.45-18.14s2.48-13.29,7.45-18.3c4.97-5.01,11.04-7.52,18.21-7.52,7.95,0,14.27,2.75,18.96,8.25,4.69,5.5,7.04,12.83,7.04,21.97v33.98h13.25v-36.6c0-11.76-3.7-21.46-11.09-29.08-7.4-7.62-16.72-11.44-27.98-11.44Z"
            />
            <path
              class="cls-1"
              d="m589.21,448.84c-7.51-7.41-16.45-11.11-26.82-11.11-7.84,0-15.12,2.67-21.86,8.01v14.21c3.97-3.59,7.42-6.04,10.35-7.35,2.92-1.31,6.37-1.96,10.35-1.96,7.17,0,13.22,2.48,18.13,7.43,4.91,4.96,7.37,11.08,7.37,18.38s-2.43,13.13-7.29,18.14c-4.86,5.01-10.76,7.51-17.72,7.51-7.95,0-14.38-2.75-19.29-8.26-4.91-5.51-7.37-13.23-7.37-23.16v-66.28h-13.25v68.88c0,12.33,3.64,22.36,10.93,30.11,7.29,7.74,16.72,11.61,28.31,11.61s20.5-3.78,28.07-11.35c7.56-7.57,11.34-16.91,11.34-28.02,0-10.46-3.75-19.39-11.26-26.79Z"
            />
            <path
              class="cls-1"
              d="m318.77,438.34h0s0,0,0,0h0c-9.93,0-17.63,3.15-23.59,9.44-5.96,6.29-8.94,14.57-8.94,24.84v42.39h14.21v-38.74c0-16.56,5.41-24.84,18.33-24.84,12.91,0,18.33,8.28,18.33,24.84v38.74h14.21v-42.39c0-10.27-2.98-18.54-8.94-24.84-5.96-6.29-13.66-9.44-23.59-9.44Z"
            />
          </svg>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List onClick={handleDrawerClose}>
          <Link
            to="/lab/management/dashboard"
            style={{ color: "inherit", textDecoration: "inherit" }}
          >
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              onClick={() => {
                setTab("dashboard");
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <PollIcon
                    color={tab == "dashboard" ? "primary" : "default"}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="داشبورد اطلاعاتی"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          </Link>
          <Link
            to="/lab/management/planning"
            style={{ color: "inherit", textDecoration: "inherit" }}
          >
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              onClick={() => {
                setTab("planning");
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <LowPriorityIcon
                    color={tab == "planning" ? "primary" : "default"}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="برنامه ریزی"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          </Link>
        </List>
        <List onClick={handleDrawerClose}>
          <Divider />
          <Link
            to="/lab/orders/newOrder"
            style={{ color: "inherit", textDecoration: "inherit" }}
          >
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              onClick={() => {
                setTab("newOrder");
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <NoteAddIcon
                    color={tab == "newOrder" ? "primary" : "default"}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="سفارش جدید"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          </Link>
          <Link
            to="/lab/orders/submitEntrance"
            style={{ color: "inherit", textDecoration: "inherit" }}
          >
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              onClick={() => {
                setTab("submitEntrance");
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <ArrowCircleLeftIcon
                    color={tab == "submitEntrance" ? "primary" : "default"}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="ورود سفارشات"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          </Link>
          <Link
            to="/lab/orders/submitExit"
            style={{ color: "inherit", textDecoration: "inherit" }}
          >
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              onClick={() => {
                setTab("submitExit");
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <ArrowCircleRightIcon
                    color={tab == "submitExit" ? "primary" : "default"}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="خروج سفارشات"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          </Link>
          <Link
            to="/lab/orders/view"
            style={{ color: "inherit", textDecoration: "inherit" }}
          >
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              onClick={() => {
                setTab("ordersView");
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <TocIcon
                    color={tab == "ordersView" ? "primary" : "default"}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="جدول سفارشات"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          </Link>
        </List>
        <List onClick={handleDrawerClose}>
          <Divider />
          <Link
            to="/lab/receipts/submit"
            style={{ color: "inherit", textDecoration: "inherit" }}
          >
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              onClick={() => {
                setTab("receiptSubmit");
              }}
            >
              <ListItemButton
                onClick={() => {
                  dispatch({
                    type: "assign",
                    payload: {
                      index: 0,
                    },
                  });
                }}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <MonetizationOnIcon
                    color={tab == "receiptSubmit" ? "primary" : "default"}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="صدور فاکتور"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          </Link>
          <Link
            to="/lab/receipts/view"
            style={{ color: "inherit", textDecoration: "inherit" }}
          >
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              onClick={() => {
                setTab("receiptView");
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <ReceiptLongIcon
                    color={tab == "receiptView" ? "primary" : "default"}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="جدول فاکتور ها"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          </Link>
        </List>
        <List onClick={handleDrawerClose}>
          <Divider />
          <Link
            to="/lab/defaults/orderTypes"
            style={{ color: "inherit", textDecoration: "inherit" }}
          >
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              onClick={() => {
                setTab("orderTypes");
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <BookmarkBorderIcon
                    color={tab == "orderTypes" ? "primary" : "default"}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="انواع کار"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          </Link>
          <Link
            to="/lab/defaults/processes"
            style={{ color: "inherit", textDecoration: "inherit" }}
          >
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              onClick={() => {
                setTab("processes");
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <AccountTreeIcon
                    color={tab == "processes" ? "primary" : "default"}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="فرایند ها"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          </Link>
          <Link
            to="/lab/defaults/doctors"
            style={{ color: "inherit", textDecoration: "inherit" }}
          >
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              onClick={() => {
                setTab("doctors");
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <GroupAddIcon
                    color={tab == "doctors" ? "primary" : "default"}
                  />
                </ListItemIcon>
                <ListItemText primary="پزشکان" sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
            </ListItem>
          </Link>
        </List>
      </Drawer>
    </Box>
  );
};

export default Navbar;
